import { getUserFields, getdirectusUserFields } from "components/user/config";
import {
  getItemFromCollection,
  addItemToCollection,
  readComments,
  createComments,
} from "directus/src/operations";

export async function fetchTicketDetails(ticketId) {
  try {
    const query = {
      fields: [
        "id",
        "title",
        "status",
        "type",
        "description",
        "attachments.attachment.id",
        "attachments.attachment.type",
        // "response",
        getUserFields("assigned_to"),
        getdirectusUserFields("user_created"),
        getdirectusUserFields("user_updated"),
        "chats.id",
        getdirectusUserFields("chats.user_created"),
        "chats.date_created",
        "chats.message",
        "chats.attachment.id",
        "chats.attachment.type",
        "priority",
        "date_created",
        "date_updated",
        "due_date",
      ],
    };
    const response = await getItemFromCollection("tickets", ticketId, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function createchat({ item }) {
  try {
    const query = {
      fields: [
        "id",
        "ticket.id",
        getdirectusUserFields("user_created"),
        "message",
        "date_created",
        "attachment.id",
        "attachment.type",
        "attachment.url",
        "attachment.name",
      ],
    };

    const data = await addItemToCollection("chats", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchTicketActivities(ticketId) {
  try {
    const query = {
      fields: [
        "id",
        "collection",
        "item",
        getdirectusUserFields("user_created"),
        "date_created",
        "comment",
        "attachment.id",
        "attachment.type",
      ],
      filter: {
        collection: { _eq: "tickets" },
        item: { _eq: ticketId },
      },
      sort: ["-date_created"],
      limit: -1,
    };

    const data = await readComments(query);
    return data || [];
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function createTicketActivity({ item }) {
  try {
    const query = {
      fields: [
        "id",
        "collection",
        "item",
        getdirectusUserFields("user_created"),
        "comment",
        "date_created",
        "attachment.id",
        "attachment.type",
        "attachment.url",
        "attachment.name",
      ],
    };

    const data = await createComments(item, query);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchTicketActivityCount(ticketId) {
  try {
    const data = await readComments({
      fields: ["id"],
      filter: { collection: { _eq: "tickets" }, item: { _eq: ticketId } },
      limit: -1,
    });
    return (data || []).length;
  } catch (error) {
    console.error(error);
    return 0;
  }
}
